export const env = {
    GOOGLE_SITE_KEY: '6Le4WAkTAAAAANEjkHV5UYNmpSUKLErQJv-AOf02',
    GOOGLE_SITE_KEY_RECAPTCHAV3: '6LeK954qAAAAANOZ54JJfdhvuaQT594uObGKaPzU'
  };